module.exports = __webpack_public_path__ + "img/hail.7cf7f47c.svg";